// JsFromRoutes CacheKey 7f5c328cfb52c05252cb3aedb33d1a26
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/email_verification/resend'),
  show: /* #__PURE__ */ definePathHelper('get', '/email_verification'),
  create: /* #__PURE__ */ definePathHelper('post', '/email_verification'),
}
